const NAME = "SIGNERS";

export default NAME;